<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', 'com_name', 'custom_date', 'rank', 'writer_name', 'department']"
      :typeslabel="{ custom_date: '점검일' }"
    />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint"
                        :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import DateSelector from '@/components/selector/DateSelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    DateSelector,
    FileUploadModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },

  data () {
    return {
      form: {
        stdInfo:{},
        fileList: [],
      },
    }
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
}
</script>

<style scoped>

</style>
